import { h as o } from "vue";
const d = (r, l) => {
  const i = "http://www.w3.org/2000/svg", t = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M4.47 4.47a.75.75 0 011.06 0L10 8.94l4.47-4.47a.75.75 0 111.06 1.06L11.06 10l4.47 4.47a.75.75 0 11-1.06 1.06L10 11.06l-4.47 4.47a.75.75 0 01-1.06-1.06L8.94 10 4.47 5.53a.75.75 0 010-1.06z" clip-rule="evenodd"/>
</svg>
`, "image/svg+xml").firstChild;
  if (r.title) {
    const e = document.createElementNS(i, "title");
    e.textContent = r.title, t.appendChild(e);
  }
  const s = Array.from((t == null ? void 0 : t.attributes) ?? []).reduce((e, n) => ({
    ...e,
    [n.name]: n.value
  }));
  return o(
    "svg",
    {
      ...s,
      ...l.attrs,
      role: "img",
      innerHTML: t.innerHTML
    }
  );
};
export {
  d as i
};
//# sourceMappingURL=CrossIcon.CBGTWrUp.js.map
